import React, { Component } from 'react';
import __ from 'lodash';

class TblKategoriKompetensi extends Component {

    constructor(props) {
        super(props);
        this.state = {             
            dataLiterasi: [],
            dataNumerasi: [],
        }
    }

    componentDidMount() {
        if(!__.isEmpty(this.props.data)) { 
            this.props.data.map(val => {
                if(val.namaMataPelajaran.toUpperCase() == 'LITERASI' ){
                    this.setState({ dataLiterasi: val.kategories })                    
                }
                if(val.namaMataPelajaran.toUpperCase() == 'NUMERASI' ){
                    this.setState({ dataNumerasi: val.kategories })
                }
            })
        }
    }

    tBody() {
        let pikLiterasi = {}, dasarLiterasi = {}, cukupLiterasi = {}, mahirLiterasi = {};
        this.state.dataLiterasi.map(d => {
            if(d.kategori === 'Perlu Intervensi Khusus') pikLiterasi = d;
            if(d.kategori === 'Dasar') dasarLiterasi = d;
            if(d.kategori === 'Cakap') cukupLiterasi = d;
            if(d.kategori === 'Mahir') mahirLiterasi = d;
        })
        
        let pikNumerasi = {}, dasarNumerasi = {}, cukupNumerasi = {}, mahirNumerasi = {};
        this.state.dataNumerasi.map(d => {
            if(d.kategori === 'Perlu Intervensi Khusus') pikNumerasi = d;
            if(d.kategori === 'Dasar') dasarNumerasi = d;
            if(d.kategori === 'Cakap') cukupNumerasi = d;
            if(d.kategori === 'Mahir') mahirNumerasi = d;
        })        
        
        return(
            <tbody>
                <tr>
                    <td> Perlu Intervensi Khusus</td>
                    <td className="text-center">{pikLiterasi.jumlah}</td>
                    <td className="text-center">{pikLiterasi.persen}</td>
                    <td className="text-center">{pikNumerasi.jumlah}</td>
                    <td className="text-center">{pikNumerasi.persen}</td>
                </tr>

                <tr>
                    <td> Dasar</td>
                    <td className="text-center">{dasarLiterasi.jumlah}</td>
                    <td className="text-center">{dasarLiterasi.persen}</td>
                    <td className="text-center">{dasarNumerasi.jumlah}</td>
                    <td className="text-center">{dasarNumerasi.persen}</td>
                </tr>

                <tr>
                    <td> Cakap</td>
                    <td className="text-center">{cukupLiterasi.jumlah}</td>
                    <td className="text-center">{cukupLiterasi.persen}</td>
                    <td className="text-center">{cukupNumerasi.jumlah}</td>
                    <td className="text-center">{cukupNumerasi.persen}</td>
                </tr>

                <tr>
                    <td> Mahir</td>
                    <td className="text-center">{mahirLiterasi.jumlah}</td>
                    <td className="text-center">{mahirLiterasi.persen}</td>
                    <td className="text-center">{mahirNumerasi.jumlah}</td>
                    <td className="text-center">{mahirNumerasi.persen}</td>
                </tr>
            </tbody>
        )
    }

    render() {        
        return (             
            <table className="table-asm" width="100%" border="1">
                <thead>
                    <tr>
                        <th className="text-center" rowSpan="2">Level Kompetensi</th>  
                        <th className="text-center" colSpan="2">Literasi</th>
                        <th className="text-center" colSpan="2">Numerasi</th>                                  
                    </tr>
                    <tr>
                        <th className="text-center">Jumsis</th>
                        <th className="text-center">%</th>
                        <th className="text-center">Jumsis</th>
                        <th className="text-center">%</th>
                    </tr>                    
                </thead> 
                    {this.tBody()}
            </table>
        )
    }   
}

export default TblKategoriKompetensi;